export default "__VITE_ASSET__$0g6TLUs__"